import React from "react";
import { message, notification, Modal } from "antd";
import { ModalProps } from "antd/lib/modal";
import { ButtonProps } from "antd/lib/button"
import { InfoCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

type ElType = "message" | "notification" | "modal";

type MessageType = "success" | "error" | "warning" | "info";

type Plactment = 'topLeft' | "topRight" | "bottomLeft" | "bottomRight";

interface PromptParams extends ModalProps {
    text: string | React.ReactNode,
    type?: MessageType,
    icon?: React.ReactNode;             //图标 
    title?: string | React.ReactNode,
    duration?: number,                  //延时时间   
    placement?: Plactment,              //弹出位置  （notification通知框）
    onClick?: () => void,                //点击回调   （用于notification通知框点击）
    onClose?: () => void,                //关闭回调   （用于notification通知框点击）
    cancelShow?: boolean                 //默认不展示 (modal 的关闭按钮是否展示)
    cancelButtonProps?: ButtonProps,     //关闭按钮的属性
    btn?: React.ReactNode
}

export function globalPrompt(
    elType: ElType,
    {
        text,
        type = "info",
        icon = "",
        title = "",
        duration = 3,
        placement = "topRight",
        onClick = () => null,
        onClose = () => null,
        cancelShow = false,
        cancelButtonProps = {},
        btn = null,
        ...params
    }: PromptParams,
) {
    if (elType === "message") {
        message.open({
            content: text,
            icon,
            type,
            duration,
        })
    } else if (elType === "notification") {
        notification[type]({
            description: text,
            message: title,
            icon,
            duration,
            placement,
            btn,
            onClick,
            onClose
        });
    } else if (elType === "modal") {
        let { style = {}, ...cancelButton } = cancelButtonProps;
        Modal.confirm({
            content: text,
            icon: modalIconType(type, icon),
            title,
            cancelButtonProps: { ...cancelButton, style: cancelShow ? { ...style } : { ...style, display: "none" } },
            ...params
        });
    }

    function modalIconType(type: string, icon?: React.ReactNode) {
        if (icon === null) return null;
        if (icon) return icon;
        switch (type) {
            case "success":
                return <CheckCircleOutlined style={{ color: "#52c41a" }} />;
            case "error":
                return <CloseCircleOutlined style={{ color: "#ff4d4f" }} />;
            case "info":
                return <InfoCircleOutlined style={{ color: "#1890ff" }} />;
            default:
                return <ExclamationCircleOutlined />
        }
    }
};